
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'academy-achievements-public-ui',
  currentProjectVersion: 'static-1.925',
  depVersions: {
  "academy-achievements-public-ui": "static-1.925",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8470",
  "hubspot-dlb": "static-2.1911",
  "react-dlb": "static-1.93",
  "academy-ai-assistant-lib": "static-1.1650",
  "academy-common-lib": "static-1.15360",
  "academy-navigation-lib": "static-1.2560",
  "analytics_js": "static-1.4507",
  "apollo-stack-hubspot": "static-3.94",
  "avatar-components": "static-1.2917",
  "classnames": "static-2.10",
  "data-fetching-client": "static-1.10078",
  "enviro": "static-4.455",
  "foundations-assets": "static-1.5319",
  "foundations-components": "static-1.8680",
  "foundations-theming": "static-1.4915",
  "graphql": "static-1.92",
  "hub-http": "static-1.6642",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11925",
  "I18n": "static-7.1698",
  "quartz": "static-1.7610",
  "quartz-config": "static-1.1388",
  "quartz-core": "static-1.6829",
  "quartz-routing": "static-1.1040",
  "quartz-tracking": "static-1.989",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17167",
  "rpc-client-utils": "static-1.5103",
  "signup-constants": "static-1.19861",
  "styled-components": "static-2.100",
  "trellis-ecosystem": "static-1.7790",
  "ui-addon-i18n": "static-1.11578",
  "UIComponents": "static-3.8871",
  "viral-links-lib": "static-1.7512",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3887",
  "quartz-webpack": "static-1.3834",
  "bend-plugin-quartz-routing": "static-1.688",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3581",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "ai-components-ui-library": "static-1.9948",
  "ai-rendering-library": "static-1.11331",
  "breeze-engine-core": "static-1.1317",
  "breeze-engine-chat-components": "static-1.1017",
  "breeze-engine-lib": "static-1.2039",
  "copilot-toolkit": "static-1.12072",
  "hs-lodash": "static-4.45",
  "magpie-lib": "static-1.5869",
  "navigation-components": "static-1.19087",
  "nest": "static-1.668",
  "pulse": "static-1.1074",
  "storybook-react": "static-1.43",
  "ts-schema": "static-1.4374",
  "zustand": "static-1.88",
  "academy-service-client": "static-1.4126",
  "croppie": "static-2.10",
  "cssUtils": "static-1.1055",
  "feedback-loader": "static-1.29997",
  "FileManagerCore": "static-1.40266",
  "FileManagerLib": "static-1.40407",
  "final-form": "static-1.82",
  "foundations-components-legacy": "static-1.1705",
  "foundations-theming-specialty": "static-1.2631",
  "hs-story-utils": "static-1.9857",
  "HubStyle": "static-2.12232",
  "icons": "static-2.699",
  "immer": "static-1.104",
  "markdown-it": "static-1.6",
  "navigation-messaging": "static-1.8414",
  "onboarding-tours": "static-1.17333",
  "PatternValidationJS": "static-1.3318",
  "quick-fetch": "static-1.4204",
  "react-utils": "static-2.5636",
  "SafeStorage": "static-1.4826",
  "sanitize-text": "static-1.8589",
  "sassPrefix": "static-1.322",
  "SharedI18nStrings": "static-1.187",
  "StyleGuideUI": "static-3.514",
  "ui-addon-react-router-dom": "static-1.9962",
  "ui-addon-video-player": "static-1.9058",
  "ui-fonts": "static-1.1187",
  "ui-images": "static-2.1269",
  "usage-tracker-container": "static-1.7737",
  "usage-tracker-core": "static-1.7597",
  "video-embed": "static-1.36851",
  "wootric-nps": "static-1.7275",
  "hub-http-janus": "static-1.901",
  "hub-http-shared-msw-handlers": "static-1.10832",
  "hubspotter-http": "static-1.4946",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4949",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.96",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2992",
  "bend-plugin-foundations-theming": "static-1.3398",
  "foundations-theming-base": "static-1.3900",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.374",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4740",
  "jasmine-runner": "static-1.6884",
  "opentelemetry-fe-types": "static-1.220",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.595",
  "quartz-auth": "static-1.1285",
  "quartz-head": "static-1.1275",
  "quartz-i18n": "static-1.1285",
  "quartz-test": "static-1.1285",
  "trellis-components": "static-1.3011",
  "usage-tracker-session-replay": "static-1.5433",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "bend-plugin-chirp-manifest": "static-1.513",
  "chirp-fetch": "static-1.2334",
  "marketplace-ui-apps-core": "static-1.19512",
  "marketplace-ui-common": "static-1.20980",
  "trellis-story-utils": "static-1.4935",
  "foundations-components-test-utils": "static-1.6163",
  "react-input-autosize": "static-2.17",
  "signup-ui-url-generator": "static-2.8491",
  "bender-build-tools": "static-1.3518",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23598",
  "ContentUtils": "static-1.69382",
  "customer-data-objects-ui-components": "static-1.13463",
  "sanitize": "static-1.4906",
  "breeze-onboarding-components": "static-1.989",
  "customer-data-filters-ui": "static-1.41258",
  "customer-data-objects": "static-1.8126",
  "customer-data-reference-ui-components": "static-1.13600",
  "data-integrations-breeze": "static-1.232",
  "embedded-academy-lib": "static-1.15900",
  "ExportDialog": "static-6.10804",
  "global-styles-ai-lib": "static-1.422",
  "highcharts": "static-8.114",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.834",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42302",
  "reporting-data": "static-1.69235",
  "reporting-snowflake": "static-1.57851",
  "reporting-ui-components": "static-2.66504",
  "reporting-visualizations": "static-1.61309",
  "trial-components-library": "static-1.14311",
  "ui-universal-auth": "static-1.9647",
  "trellis-theming": "static-1.1419",
  "ui-addon-teams": "static-1.21970",
  "ui-addon-upgrades": "static-9.18524",
  "upgrade-components-lib": "static-1.673",
  "breeze-artifacts-sdk": "static-1.749",
  "ably": "static-2.2",
  "batch-promise": "static-1.1979",
  "superstore": "static-1.5191",
  "magpie-types": "static-1.5329",
  "simple-logging-lib": "static-1.3484",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1156",
  "bend-plugin-pulse": "static-1.577",
  "event-emitter": "static-1.1393",
  "fast-json-patch": "static-1.73",
  "nudge-client-utils": "static-1.3345",
  "audio-components": "static-1.6510",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.24767",
  "FileManagerImages": "static-1.37918",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4573",
  "react-colorpicker": "static-2.10645",
  "redux-toolkit": "static-1.81",
  "reselect": "static-3.15",
  "salesImages": "static-1.689",
  "urlinator": "static-1.4948",
  "usage-tracker": "static-1.7747",
  "video-components": "static-1.14361",
  "video-data-lib": "static-1.36017",
  "redux-thunk": "static-2.83",
  "nav-meta": "static-1.30724",
  "getting-started-shared-tasks": "static-1.19489",
  "growth-data-modal": "static-1.6070",
  "growth-onboarding-confetti": "static-1.3495",
  "growth-onboarding-next-action-utils": "static-1.2913",
  "onboarding-tours-client": "static-1.5548",
  "onboarding-tours-utils": "static-1.1400",
  "ui-shepherd-react": "static-3.10708",
  "ui-shepherd-tracker": "static-1.8089",
  "user-context": "static-1.5484",
  "transmute": "static-2.97",
  "outpost": "static-1.4566",
  "stylex-utils": "static-1.166",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.133",
  "hubspotter-http-shared-msw-handlers": "static-1.10830",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "developer-experience-shared-components": "static-1.10971",
  "immutable-less": "static-1.5084",
  "marketplace-ui-client-types": "static-1.18387",
  "ui-addon-iframeable": "static-1.9509",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4349",
  "ai-settings-ui-library": "static-1.8516",
  "integrations-lib": "static-1.17328",
  "laboratory-lib": "static-3.7583",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1468",
  "cms-field-types": "static-1.5245",
  "content-icons-ui": "static-1.2418",
  "underscore": "static-1.8",
  "atom": "static-1.5510",
  "customer-data-ui-utilities": "static-1.10266",
  "property-translator": "static-1.5812",
  "reference-resolvers": "static-1.8611",
  "onboarding-journeys-lib": "static-1.1166",
  "onboarding-scopes": "static-1.6886",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.44019",
  "customer-data-filters-ui-msw-helpers": "static-1.23693",
  "customer-data-property-utils": "static-1.8477",
  "events-data-lib": "static-1.679",
  "FormUrlGenerator": "static-2.5147",
  "framework-builder-read-service-client": "static-1.4305",
  "hs-resources": "static-1.630",
  "inbound-db-meta-service-client": "static-1.3752",
  "inbound-db-properties-service-client": "static-1.4123",
  "multi-account-reference-resolvers": "static-1.1435",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers-lite": "static-1.8539",
  "reporting-datasets-permissions-lib": "static-1.14696",
  "segments-client-types": "static-1.12036",
  "marketplace-embed": "static-1.23131",
  "marketplace-ui-install": "static-1.966",
  "marketplace-ui-tracking": "static-1.15150",
  "content-assistance-lib": "static-1.8360",
  "dashboard-lib": "static-1.83201",
  "frontend-preferences-client": "static-1.8350",
  "hubspot-prosemirror": "static-1.19210",
  "hubspot-prosemirror-plugins": "static-1.19202",
  "prosemirror": "static-1.13",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "rich-text-lib": "static-1.20491",
  "share-with-third-party-component-lib": "static-1.9144",
  "ui-addon-draggable": "static-3.5180",
  "ui-asset-management-lib": "static-1.11535",
  "ui-business-units-lib": "static-1.9528",
  "persist-promise": "static-1.4136",
  "reporting-client-types": "static-1.2797",
  "growth-payments-core": "static-1.26426",
  "hubspot-apollo-client": "static-1.5311",
  "reporting-plugins": "static-1.10914",
  "reporting-reports": "static-1.68911",
  "hs-promise-utils": "static-1.6022",
  "hubs-service-types": "static-1.1697",
  "merchandise-lib": "static-1.283",
  "purchase-motions-api": "static-1.6584",
  "purchase-motions-components": "static-1.6581",
  "unified-auth-core-lib": "static-1.1443",
  "nudge-custom-function-registry": "static-1.3102",
  "nudge-renderer-utils": "static-1.3421",
  "whisper-core-api": "static-1.7567",
  "apollo-link-hub-http": "static-2.5022",
  "poll-commands": "static-1.3907",
  "video-components-external": "static-1.12359",
  "social-insights-client-types": "static-1.22866",
  "onboarding-data-sync-lib": "static-1.2776",
  "growth-onboarding-next-action-components": "static-1.2941",
  "user-context-client": "static-1.4942",
  "getting-started-shared-tasks-store": "static-1.18607",
  "apps-service-types": "static-1.4080",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12963",
  "simple-data-table": "static-1.3756",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14743",
  "integrations-tracking-lib": "static-1.6045",
  "native-integrations-shared-strings": "static-1.8195",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10804",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1161",
  "react-dnd-compat": "static-1.5043",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1948",
  "conditional-properties-service-client": "static-1.4094",
  "crm-pipelines-api-client-types": "static-1.4425",
  "fdsr-migration-layer": "static-1.444",
  "multi-currency-client-types": "static-1.3990",
  "external-options-client-types": "static-1.4423",
  "crm-index-associations-lib": "static-1.6881",
  "connections-embed-lib": "static-1.1681",
  "fail-safe": "static-1.385",
  "ai-studio-lib": "static-1.12682",
  "integrations-reconnect-lib": "static-1.654",
  "ui-product-approvals": "static-1.29573",
  "ui-tool-access": "static-1.10588",
  "ui-coaching-tips": "static-1.29531",
  "redux-actions": "static-3.73",
  "content-media-capture": "static-1.5709",
  "emoji-mart": "static-3.6",
  "knowledge-content-types": "static-1.8719",
  "payment-link-components": "static-1.24370",
  "ui-addon-emoji-picker": "static-1.10299",
  "EmailSignatureEditor": "static-1.25180",
  "data-token-picker": "static-1.17063",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.668",
  "seat-types-lib": "static-1.972",
  "timezone-utils": "static-2.5663",
  "ui-addon-opt": "static-4.8817",
  "hubspot-apollo-cache": "static-1.770",
  "campaign-roi-lib": "static-1.10698",
  "campaigns-utils-lib": "static-1.3667",
  "ui-addon-calendars": "static-2.5796",
  "fsm": "static-1.4189",
  "content-media-composition-data-lib": "static-1.13513",
  "content-media-compositions": "static-2.17520",
  "media-bridge-lib": "static-1.19581",
  "InboxConnectUtils": "static-4.15774",
  "meetings-connect-utils-lib": "static-1.8049",
  "universal-page-editor-lib": "static-1.3441",
  "adobe-sign-auth-lib": "static-1.691",
  "ads-unified-auth-lib": "static-1.1820",
  "custom-vendor-connection-lib": "static-1.211",
  "google-sheets-integration-lib": "static-1.1259",
  "microsoft-drive-auth-lib": "static-1.419",
  "surveymonkey-integration-lib": "static-1.786",
  "slack-ui-library": "static-1.10829",
  "bend-plugin-fail-safe": "static-1.336",
  "codemirror": "static-5.105",
  "property-management-iframe": "static-1.14380",
  "react-codemirror": "static-1.11072",
  "collaboration-sidebar": "static-1.58972",
  "trellis-ext-dnd": "static-1.477",
  "growth-onboarding-feedback-components": "static-1.7015",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4859",
  "commerce-tours-lib": "static-1.6801",
  "customer-data-properties": "static-1.52937",
  "growth-onboarding-reliability": "static-1.5514",
  "sales-checkout-service-client": "static-1.3959",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22293",
  "sales-email-signature-service-client": "static-1.4283",
  "ts-utils-lib": "static-1.581",
  "copilot-messaging": "static-1.2322",
  "js-cookie": "static-1.18",
  "hub-http-contrib": "static-1.3461",
  "ui-addon-sales-email": "static-1.5635",
  "crm-record-cards-service-types": "static-1.3844",
  "framework-data-schema-resolvers": "static-1.7325",
  "location-customization-utils-lib": "static-1.10345",
  "diff-match-patch": "static-1.7",
  "property-management-common": "static-1.6668",
  "browser-eslint": "static-2.57",
  "chatspot-widget-iframe": "static-1.23589",
  "collaboration-sidebar-common": "static-1.3769",
  "marketing-platform-lib": "static-1.7326",
  "dnd-kit": "static-1.20",
  "commerce-products-lib": "static-1.10797",
  "calling-global-api": "static-1.66070",
  "calling-internal-common": "static-1.31758",
  "calling-lifecycle-internal": "static-1.67452",
  "calling-lifecycle-messages": "static-1.59745",
  "crm-index-visualization-core": "static-1.4699",
  "crm-links": "static-1.6737",
  "customer-data-properties-shared-msw-handlers": "static-1.10159",
  "formula-editor": "static-1.14953",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4504",
  "meetings-icalendar-utils-lib": "static-1.1070",
  "object-builder-ui-client": "static-1.49960",
  "pipeline-validation-client-types": "static-1.4262",
  "property-value-citations": "static-1.3551",
  "smart-data-capture-core": "static-1.394",
  "smart-property-lib": "static-1.8554",
  "tiered-pricing": "static-1.2165",
  "topics-actions-lib": "static-1.608",
  "trellis-ext-i18n": "static-1.1321",
  "ui-addon-form-validation": "static-1.11341",
  "framework-data-schema-quick-fetch": "static-1.7230",
  "crm-component-utils": "static-1.40096",
  "crm-properties-common-lib": "static-1.6321",
  "commerce-permissions": "static-1.1214",
  "customer-data-tracking": "static-1.7305",
  "products-iframe-lib": "static-1.8829",
  "products-ui-components-shared-msw-handlers": "static-1.11214",
  "calling-error-reporting": "static-1.31765",
  "shared-worker-versioning": "static-1.11474",
  "calling-usage-tracker": "static-1.6967",
  "voice-sms-access-library": "static-1.2348",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10915",
  "sales-views-client-types": "static-1.4691",
  "bark-lib": "static-1.16963",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.837",
  "data-agent-test-utils": "static-1.381",
  "data-agent-utils": "static-1.850",
  "policy-lib": "static-1.7239",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10978",
  "card-properties-lib": "static-1.45256",
  "commerce-subscription-lib": "static-1.38020",
  "crm-actions": "static-1.6783",
  "crm-cards-sdk": "static-1.44910",
  "calling-orchestration-schema": "static-1.37125",
  "react-reducer-toolkit": "static-1.16595",
  "enrichment-settings-lib": "static-1.165",
  "crm_data": "static-4.93119",
  "customer-data-sidebar": "static-2.46947",
  "enrichment-lib": "static-1.820",
  "smart-property-fill-lib": "static-1.572",
  "ui-addon-draggable-compat": "static-2.4694",
  "universal-record-utils-lib": "static-1.2277",
  "commerce-billing-lib": "static-1.20460",
  "commerce-shared-components-lib": "static-1.19496",
  "commerce-tools-ui-lib": "static-1.11252",
  "crm-fe-perf": "static-1.23329",
  "crm_universal": "static-1.22662",
  "customer-data-email": "static-1.18594",
  "card-payment-highlight-lib": "static-1.38231",
  "commerce-contract-lib": "static-1.13693",
  "invoices-highlight-card-lib": "static-1.56079",
  "orders-highlight-card-lib": "static-1.22431",
  "products-highlight-card-lib": "static-1.19080",
  "quotes-highlight-card-lib": "static-1.73019",
  "crm-source-interpretation-lib": "static-1.5760",
  "usage-based-billing-components-lib": "static-1.10662",
  "access-check-ui-lib": "static-1.1815",
  "data-agent-usage-based-billing": "static-1.25",
  "crm-object-search-query-utilities": "static-1.10395",
  "utility-belt": "static-1.2968",
  "customer-data-associations": "static-1.7765",
  "framework-data-table": "static-2.12772",
  "payments-enrollment-embed-lib": "static-1.24124",
  "stripe-embedded-components": "static-1.8178",
  "customer-data-rte": "static-1.33831",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6467",
  "payments-post-enroll-local-storage-lib": "static-1.5536",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39109",
  "sequences-lib": "static-1.8706",
  "ui-gdpr-components": "static-1.10651",
  "products-ui-components": "static-1.41315",
  "reporting-enablement": "static-1.24092",
  "accounting-integrations-ui-components": "static-1.7733",
  "invoices-ui-lib": "static-1.56095",
  "commerce-products-api": "static-1.2858",
  "invoices-iframe-lib": "static-1.58153",
  "quotes-modal-lib": "static-1.103697",
  "quotes-ui-lib": "static-1.81740",
  "one-click-checkout": "static-1.685",
  "platform-infra-nav-components": "static-1.7978",
  "subscription-experience-data-types": "static-1.15385",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "tasks-actions-lib": "static-1.363",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29089",
  "sequences-client-types-lib": "static-1.8563",
  "commerce-tax-lib": "static-1.969",
  "price-books-api": "static-1.1964",
  "price-books-components": "static-1.2022",
  "property-description-translator": "static-1.4253",
  "ramp-editor": "static-1.1099",
  "data-quality-ui-library": "static-1.14191",
  "report-customization-components": "static-1.14138",
  "reporting-filters": "static-1.1225",
  "reporting-insights-lib": "static-1.2848",
  "commerce-analytics-service-client": "static-1.3947",
  "totals-ui-components": "static-1.24497",
  "SalesContentIndexUI": "static-3.9692",
  "checkout-sdk": "static-3.24623",
  "payment-method-components": "static-1.7277",
  "touchless-buying-components": "static-1.6491",
  "upgrade-catalog-service-types": "static-1.3857",
  "edison-service-client-types": "static-1.826",
  "line-items-api": "static-1.1269",
  "merge-modal-lib": "static-1.12947",
  "commerce-totals-service-types": "static-1.4113",
  "FireAlarmUi": "static-1.4819",
  "sales-templates-service-types-lib": "static-1.4465",
  "hub-http-rxjs": "static-1.870",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4422",
  "company-details-components": "static-1.6637",
  "emoji-regex": "static-1.7",
  "react-performance-metrics-lib": "static-1.984",
  "pricing-pages-ui-components": "static-1.16384",
  "quote-checkout-service-types": "static-1.3889",
  "tinymce-plugins": "static-1.58438",
  "company-details-service-types": "static-1.4376",
  "segments-query-core": "static-1.1862",
  "pricing-pages-api": "static-1.16249",
  "interframe": "static-3.5173",
  "layout-dnd-components": "static-1.13154",
  "layout-dnd-utils": "static-1.12129",
  "tinymce": "static-5.11",
  "tinymce-data": "static-1.41409",
  "tinymce-themes": "static-1.57294",
  "ui-brand-identity-lib": "static-1.16846",
  "ContentData": "static-1.69457",
  "layout-data-lib": "static-1.10454",
  "NamespacedHubStyle": "static-2.9339",
  "advanced-menus-core": "static-1.15749",
  "advanced-menus-lib": "static-1.12515",
  "ui-memberships-settings-lib": "static-1.35106",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15748",
  "simple-menus-lib": "static-1.17265"
},
  depPathPrefixes: {
  "academy-achievements-public-ui": "/academy-achievements-public-ui/static-1.925",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8470",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "react-dlb": "/react-dlb/static-1.93",
  "academy-ai-assistant-lib": "/academy-ai-assistant-lib/static-1.1650",
  "academy-common-lib": "/academy-common-lib/static-1.15360",
  "academy-navigation-lib": "/academy-navigation-lib/static-1.2560",
  "analytics_js": "/analytics_js/static-1.4507",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "avatar-components": "/avatar-components/static-1.2917",
  "classnames": "/classnames/static-2.10",
  "data-fetching-client": "/data-fetching-client/static-1.10078",
  "enviro": "/enviro/static-4.455",
  "foundations-assets": "/foundations-assets/static-1.5319",
  "foundations-components": "/foundations-components/static-1.8680",
  "foundations-theming": "/foundations-theming/static-1.4915",
  "graphql": "/graphql/static-1.92",
  "hub-http": "/hub-http/static-1.6642",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11925",
  "I18n": "/I18n/static-7.1698",
  "quartz": "/quartz/static-1.7610",
  "quartz-config": "/quartz-config/static-1.1388",
  "quartz-core": "/quartz-core/static-1.6829",
  "quartz-routing": "/quartz-routing/static-1.1040",
  "quartz-tracking": "/quartz-tracking/static-1.989",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17167",
  "rpc-client-utils": "/rpc-client-utils/static-1.5103",
  "signup-constants": "/signup-constants/static-1.19861",
  "styled-components": "/styled-components/static-2.100",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7790",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11578",
  "UIComponents": "/UIComponents/static-3.8871",
  "viral-links-lib": "/viral-links-lib/static-1.7512",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3887",
  "quartz-webpack": "/quartz-webpack/static-1.3834",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.688",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3581",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9948",
  "ai-rendering-library": "/ai-rendering-library/static-1.11331",
  "breeze-engine-core": "/breeze-engine-core/static-1.1317",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1017",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2039",
  "copilot-toolkit": "/copilot-toolkit/static-1.12072",
  "hs-lodash": "/hs-lodash/static-4.45",
  "magpie-lib": "/magpie-lib/static-1.5869",
  "navigation-components": "/navigation-components/static-1.19087",
  "nest": "/nest/static-1.668",
  "pulse": "/pulse/static-1.1074",
  "storybook-react": "/storybook-react/static-1.43",
  "ts-schema": "/ts-schema/static-1.4374",
  "zustand": "/zustand/static-1.88",
  "academy-service-client": "/academy-service-client/static-1.4126",
  "croppie": "/croppie/static-2.10",
  "cssUtils": "/cssUtils/static-1.1055",
  "feedback-loader": "/feedback-loader/static-1.29997",
  "FileManagerCore": "/FileManagerCore/static-1.40266",
  "FileManagerLib": "/FileManagerLib/static-1.40407",
  "final-form": "/final-form/static-1.82",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1705",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2631",
  "hs-story-utils": "/hs-story-utils/static-1.9857",
  "HubStyle": "/HubStyle/static-2.12232",
  "icons": "/icons/static-2.699",
  "immer": "/immer/static-1.104",
  "markdown-it": "/markdown-it/static-1.6",
  "navigation-messaging": "/navigation-messaging/static-1.8414",
  "onboarding-tours": "/onboarding-tours/static-1.17333",
  "PatternValidationJS": "/PatternValidationJS/static-1.3318",
  "quick-fetch": "/quick-fetch/static-1.4204",
  "react-utils": "/react-utils/static-2.5636",
  "SafeStorage": "/SafeStorage/static-1.4826",
  "sanitize-text": "/sanitize-text/static-1.8589",
  "sassPrefix": "/sassPrefix/static-1.322",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9962",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9058",
  "ui-fonts": "/ui-fonts/static-1.1187",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-container": "/usage-tracker-container/static-1.7737",
  "usage-tracker-core": "/usage-tracker-core/static-1.7597",
  "video-embed": "/video-embed/static-1.36851",
  "wootric-nps": "/wootric-nps/static-1.7275",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10832",
  "hubspotter-http": "/hubspotter-http/static-1.4946",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4949",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2992",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3398",
  "foundations-theming-base": "/foundations-theming-base/static-1.3900",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.374",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4740",
  "jasmine-runner": "/jasmine-runner/static-1.6884",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.220",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.595",
  "quartz-auth": "/quartz-auth/static-1.1285",
  "quartz-head": "/quartz-head/static-1.1275",
  "quartz-i18n": "/quartz-i18n/static-1.1285",
  "quartz-test": "/quartz-test/static-1.1285",
  "trellis-components": "/trellis-components/static-1.3011",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5433",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.513",
  "chirp-fetch": "/chirp-fetch/static-1.2334",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19512",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20980",
  "trellis-story-utils": "/trellis-story-utils/static-1.4935",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6163",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8491",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23598",
  "ContentUtils": "/ContentUtils/static-1.69382",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13463",
  "sanitize": "/sanitize/static-1.4906",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.989",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41258",
  "customer-data-objects": "/customer-data-objects/static-1.8126",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13600",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.232",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15900",
  "ExportDialog": "/ExportDialog/static-6.10804",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.422",
  "highcharts": "/highcharts/static-8.114",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.834",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42302",
  "reporting-data": "/reporting-data/static-1.69235",
  "reporting-snowflake": "/reporting-snowflake/static-1.57851",
  "reporting-ui-components": "/reporting-ui-components/static-2.66504",
  "reporting-visualizations": "/reporting-visualizations/static-1.61309",
  "trial-components-library": "/trial-components-library/static-1.14311",
  "ui-universal-auth": "/ui-universal-auth/static-1.9647",
  "trellis-theming": "/trellis-theming/static-1.1419",
  "ui-addon-teams": "/ui-addon-teams/static-1.21970",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18524",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.673",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.749",
  "ably": "/ably/static-2.2",
  "batch-promise": "/batch-promise/static-1.1979",
  "superstore": "/superstore/static-1.5191",
  "magpie-types": "/magpie-types/static-1.5329",
  "simple-logging-lib": "/simple-logging-lib/static-1.3484",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1156",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.577",
  "event-emitter": "/event-emitter/static-1.1393",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "nudge-client-utils": "/nudge-client-utils/static-1.3345",
  "audio-components": "/audio-components/static-1.6510",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.24767",
  "FileManagerImages": "/FileManagerImages/static-1.37918",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4573",
  "react-colorpicker": "/react-colorpicker/static-2.10645",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "reselect": "/reselect/static-3.15",
  "salesImages": "/salesImages/static-1.689",
  "urlinator": "/urlinator/static-1.4948",
  "usage-tracker": "/usage-tracker/static-1.7747",
  "video-components": "/video-components/static-1.14361",
  "video-data-lib": "/video-data-lib/static-1.36017",
  "redux-thunk": "/redux-thunk/static-2.83",
  "nav-meta": "/nav-meta/static-1.30724",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19489",
  "growth-data-modal": "/growth-data-modal/static-1.6070",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3495",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2913",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5548",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1400",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10708",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8089",
  "user-context": "/user-context/static-1.5484",
  "transmute": "/transmute/static-2.97",
  "outpost": "/outpost/static-1.4566",
  "stylex-utils": "/stylex-utils/static-1.166",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.133",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10830",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10971",
  "immutable-less": "/immutable-less/static-1.5084",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18387",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9509",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4349",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8516",
  "integrations-lib": "/integrations-lib/static-1.17328",
  "laboratory-lib": "/laboratory-lib/static-3.7583",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1468",
  "cms-field-types": "/cms-field-types/static-1.5245",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.5510",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10266",
  "property-translator": "/property-translator/static-1.5812",
  "reference-resolvers": "/reference-resolvers/static-1.8611",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1166",
  "onboarding-scopes": "/onboarding-scopes/static-1.6886",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.44019",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23693",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8477",
  "events-data-lib": "/events-data-lib/static-1.679",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5147",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4305",
  "hs-resources": "/hs-resources/static-1.630",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3752",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4123",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1435",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8539",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14696",
  "segments-client-types": "/segments-client-types/static-1.12036",
  "marketplace-embed": "/marketplace-embed/static-1.23131",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.966",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15150",
  "content-assistance-lib": "/content-assistance-lib/static-1.8360",
  "dashboard-lib": "/dashboard-lib/static-1.83201",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8350",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19210",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19202",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "rich-text-lib": "/rich-text-lib/static-1.20491",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9144",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5180",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11535",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9528",
  "persist-promise": "/persist-promise/static-1.4136",
  "reporting-client-types": "/reporting-client-types/static-1.2797",
  "growth-payments-core": "/growth-payments-core/static-1.26426",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5311",
  "reporting-plugins": "/reporting-plugins/static-1.10914",
  "reporting-reports": "/reporting-reports/static-1.68911",
  "hs-promise-utils": "/hs-promise-utils/static-1.6022",
  "hubs-service-types": "/hubs-service-types/static-1.1697",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-api": "/purchase-motions-api/static-1.6584",
  "purchase-motions-components": "/purchase-motions-components/static-1.6581",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1443",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3102",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3421",
  "whisper-core-api": "/whisper-core-api/static-1.7567",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "poll-commands": "/poll-commands/static-1.3907",
  "video-components-external": "/video-components-external/static-1.12359",
  "social-insights-client-types": "/social-insights-client-types/static-1.22866",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2776",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2941",
  "user-context-client": "/user-context-client/static-1.4942",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18607",
  "apps-service-types": "/apps-service-types/static-1.4080",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12963",
  "simple-data-table": "/simple-data-table/static-1.3756",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14743",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6045",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8195",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10804",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1161",
  "react-dnd-compat": "/react-dnd-compat/static-1.5043",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1948",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4094",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4425",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.444",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3990",
  "external-options-client-types": "/external-options-client-types/static-1.4423",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6881",
  "connections-embed-lib": "/connections-embed-lib/static-1.1681",
  "fail-safe": "/fail-safe/static-1.385",
  "ai-studio-lib": "/ai-studio-lib/static-1.12682",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.654",
  "ui-product-approvals": "/ui-product-approvals/static-1.29573",
  "ui-tool-access": "/ui-tool-access/static-1.10588",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29531",
  "redux-actions": "/redux-actions/static-3.73",
  "content-media-capture": "/content-media-capture/static-1.5709",
  "emoji-mart": "/emoji-mart/static-3.6",
  "knowledge-content-types": "/knowledge-content-types/static-1.8719",
  "payment-link-components": "/payment-link-components/static-1.24370",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10299",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25180",
  "data-token-picker": "/data-token-picker/static-1.17063",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.668",
  "seat-types-lib": "/seat-types-lib/static-1.972",
  "timezone-utils": "/timezone-utils/static-2.5663",
  "ui-addon-opt": "/ui-addon-opt/static-4.8817",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.770",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10698",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3667",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5796",
  "fsm": "/fsm/static-1.4189",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13513",
  "content-media-compositions": "/content-media-compositions/static-2.17520",
  "media-bridge-lib": "/media-bridge-lib/static-1.19581",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15774",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8049",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3441",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.691",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1820",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.211",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1259",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.419",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.786",
  "slack-ui-library": "/slack-ui-library/static-1.10829",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.336",
  "codemirror": "/codemirror/static-5.105",
  "property-management-iframe": "/property-management-iframe/static-1.14380",
  "react-codemirror": "/react-codemirror/static-1.11072",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58972",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7015",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4859",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6801",
  "customer-data-properties": "/customer-data-properties/static-1.52937",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5514",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3959",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22293",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4283",
  "ts-utils-lib": "/ts-utils-lib/static-1.581",
  "copilot-messaging": "/copilot-messaging/static-1.2322",
  "js-cookie": "/js-cookie/static-1.18",
  "hub-http-contrib": "/hub-http-contrib/static-1.3461",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5635",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3844",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7325",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10345",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "property-management-common": "/property-management-common/static-1.6668",
  "browser-eslint": "/browser-eslint/static-2.57",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23589",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3769",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7326",
  "dnd-kit": "/dnd-kit/static-1.20",
  "commerce-products-lib": "/commerce-products-lib/static-1.10797",
  "calling-global-api": "/calling-global-api/static-1.66070",
  "calling-internal-common": "/calling-internal-common/static-1.31758",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67452",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59745",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4699",
  "crm-links": "/crm-links/static-1.6737",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10159",
  "formula-editor": "/formula-editor/static-1.14953",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4504",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1070",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49960",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4262",
  "property-value-citations": "/property-value-citations/static-1.3551",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.394",
  "smart-property-lib": "/smart-property-lib/static-1.8554",
  "tiered-pricing": "/tiered-pricing/static-1.2165",
  "topics-actions-lib": "/topics-actions-lib/static-1.608",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1321",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7230",
  "crm-component-utils": "/crm-component-utils/static-1.40096",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6321",
  "commerce-permissions": "/commerce-permissions/static-1.1214",
  "customer-data-tracking": "/customer-data-tracking/static-1.7305",
  "products-iframe-lib": "/products-iframe-lib/static-1.8829",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11214",
  "calling-error-reporting": "/calling-error-reporting/static-1.31765",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11474",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6967",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2348",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10915",
  "sales-views-client-types": "/sales-views-client-types/static-1.4691",
  "bark-lib": "/bark-lib/static-1.16963",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.837",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.381",
  "data-agent-utils": "/data-agent-utils/static-1.850",
  "policy-lib": "/policy-lib/static-1.7239",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10978",
  "card-properties-lib": "/card-properties-lib/static-1.45256",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38020",
  "crm-actions": "/crm-actions/static-1.6783",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44910",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37125",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16595",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.165",
  "crm_data": "/crm_data/static-4.93119",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46947",
  "enrichment-lib": "/enrichment-lib/static-1.820",
  "smart-property-fill-lib": "/smart-property-fill-lib/static-1.572",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4694",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2277",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20460",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19496",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11252",
  "crm-fe-perf": "/crm-fe-perf/static-1.23329",
  "crm_universal": "/crm_universal/static-1.22662",
  "customer-data-email": "/customer-data-email/static-1.18594",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38231",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13693",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56079",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22431",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19080",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.73019",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5760",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10662",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1815",
  "data-agent-usage-based-billing": "/data-agent-usage-based-billing/static-1.25",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10395",
  "utility-belt": "/utility-belt/static-1.2968",
  "customer-data-associations": "/customer-data-associations/static-1.7765",
  "framework-data-table": "/framework-data-table/static-2.12772",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24124",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8178",
  "customer-data-rte": "/customer-data-rte/static-1.33831",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6467",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5536",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39109",
  "sequences-lib": "/sequences-lib/static-1.8706",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "products-ui-components": "/products-ui-components/static-1.41315",
  "reporting-enablement": "/reporting-enablement/static-1.24092",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7733",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56095",
  "commerce-products-api": "/commerce-products-api/static-1.2858",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58153",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103697",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81740",
  "one-click-checkout": "/one-click-checkout/static-1.685",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7978",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15385",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.363",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29089",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8563",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.969",
  "price-books-api": "/price-books-api/static-1.1964",
  "price-books-components": "/price-books-components/static-1.2022",
  "property-description-translator": "/property-description-translator/static-1.4253",
  "ramp-editor": "/ramp-editor/static-1.1099",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14191",
  "report-customization-components": "/report-customization-components/static-1.14138",
  "reporting-filters": "/reporting-filters/static-1.1225",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2848",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3947",
  "totals-ui-components": "/totals-ui-components/static-1.24497",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9692",
  "checkout-sdk": "/checkout-sdk/static-3.24623",
  "payment-method-components": "/payment-method-components/static-1.7277",
  "touchless-buying-components": "/touchless-buying-components/static-1.6491",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3857",
  "edison-service-client-types": "/edison-service-client-types/static-1.826",
  "line-items-api": "/line-items-api/static-1.1269",
  "merge-modal-lib": "/merge-modal-lib/static-1.12947",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4113",
  "FireAlarmUi": "/FireAlarmUi/static-1.4819",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4465",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.870",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4422",
  "company-details-components": "/company-details-components/static-1.6637",
  "emoji-regex": "/emoji-regex/static-1.7",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.984",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16384",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3889",
  "tinymce-plugins": "/tinymce-plugins/static-1.58438",
  "company-details-service-types": "/company-details-service-types/static-1.4376",
  "segments-query-core": "/segments-query-core/static-1.1862",
  "pricing-pages-api": "/pricing-pages-api/static-1.16249",
  "interframe": "/interframe/static-3.5173",
  "layout-dnd-components": "/layout-dnd-components/static-1.13154",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12129",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-data": "/tinymce-data/static-1.41409",
  "tinymce-themes": "/tinymce-themes/static-1.57294",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16846",
  "ContentData": "/ContentData/static-1.69457",
  "layout-data-lib": "/layout-data-lib/static-1.10454",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9339",
  "advanced-menus-core": "/advanced-menus-core/static-1.15749",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12515",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35106",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15748",
  "simple-menus-lib": "/simple-menus-lib/static-1.17265"
}
};
